// The app-wide type face.
//
// GlobalStyles forces this on EVERY element with `*{font-family:…!important}` — deliberately,
// because dozens of inline styles still name IBM Plex Mono and the app standardised on a
// condensed face without rewriting them all. See the rule there for the full reasoning.
//
// It lives here, and not inline in that CSS string, because code that MEASURES text has to
// measure the face that will actually render. Reading the family off the inline style — as the
// timeline's label-width estimates used to, by assuming IBM Plex Mono's 0.6em advance — over-
// states the width by roughly a third, since the condensed face is far narrower. One constant,
// so the rule and the measurements cannot drift.
export const APP_FONT_FAMILY = '"IBM Plex Sans","Helvetica Neue",Arial,sans-serif';

// Figures, axes and IDs: opt in with the `sy-mono` class (GlobalStyles).
export const APP_MONO_FAMILY = '"IBM Plex Mono",ui-monospace,Menlo,monospace';

// The default tracking that same rule sets. NOT forced (no `!important`) — an element with its
// own letter-spacing keeps it — so this is only what applies when nothing overrides.
export const APP_LETTER_SPACING = 0;
